import styled from "styled-components";
import { devices } from "../../ExternFormEnrollment.styles";

export const Container = styled.div`
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 25px;
  @media ${devices.tablet} { 
  flex-direction: row;
  gap: 15px;
  }
`;

export const Question = styled.p`
  margin-bottom: 20px;
`;

export const QuestionPaymentDuration = styled.p`
  margin-bottom: 4px;
`;

export const Bankdiv = styled.div`
  background-color: rgb(243, 243, 243);
  padding: 16px 12px;
  margin: 16px 0px 20px 0px;
`;

export const InputRow = styled.div`
  width: 100%;
  display: flex;
`;

export const ColReg = styled.div`
  width: 40%;
  margin-right: 15px;
`;

export const ColAccNumb = styled.div`
  width: 60%;
`;

export const HelpText = styled.p`
  font-size: 14px;
  margin-top: -18px;
  margin-bottom: 28px;
  margin-left: 2px;
`;

export const PaymentoptionsDiv = styled.div`
  display: flex;
  gap: 24px;
`;

export const MobilepayDiv = styled.div<{selected: boolean}>`
  background-color: #f1f1f1;
  border-radius: 8px;
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid var(--color-coal); 
  }
  &:hover {
    outline: 2px solid var(--color-petrol);
  }
  ${({ selected }) => selected && `
    outline: 3px solid var(--color-petrol);
  `}
`;

export const BSDiv = styled.div<{selected: boolean}>`
  background-color: #f1f1f1;  
  border-radius: 8px; 
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid var(--color-coal); 
  }
  &:hover {
    outline: 2px solid var(--color-petrol);
  }  
  ${({ selected }) => selected && `
    outline: 3px solid var(--color-petrol);
  `}
`;

export const RegisterLaterDiv = styled.div<{selected: boolean}>`
  background-color: #f1f1f1;
  border-radius: 8px;
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid var(--color-coal);
  }
  &:hover {
    outline: 2px solid var(--color-petrol);
  }
  ${({ selected }) => selected && `
    outline: 3px solid var(--color-petrol);
  `}
`;

export const MobilepaySvg = styled.img`
  width: 40px;
`;

export const BsImg = styled.img`
  width: 65px;
  hieght: 65px;
`;

export const PaymentName = styled.p`
  margin-top: 4px;
  font-size: 14px;
`;

export const BSpaymentDiv = styled.div`
  margin-top: 20px;
`;

export const MobilePayInfo = styled.p`
 font-size: 16px;
`;
export const BackgroundColor = styled.div` 
  background-color: var(--color-greylight);
  padding: 20px;
  width: 100%;
`;
export const DiscountCodeDiv = styled.div`
  margin-top: 20px;
`;

export const DiscountButton = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;